import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Tabbar from '@/components/Tabbar/TabbarIndex.vue'
import { staticAllData, getSignature } from '@/api/home'
import { onMounted } from 'vue';
import wx from 'weixin-js-sdk'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const getStaticAllData = () => {
  const newsTarget = {
    deptName: process.env.VUE_APP_BASE_SITE
  }
  staticAllData(newsTarget).then()
}
const goToApp = () => {
  //签名的URL
  let sign_url = "";
  if (window.__wxjs_is_wkwebview === true) {
    //如果当前设备是IOS
    sign_url = window.location.href.split("#")[0];
  } else {
    //非IOS设备
    sign_url = window.location.href;
  }
  getSignature({ url: encodeURI(sign_url), accessToken: localStorage.getItem('accessToken') }).then(res => {
    if (res.data.code === 200) {
      wx.config({
        debug: false, // 开启调试模式,
        appId: 'wx19c688b89331ea44', // 必填，企业号的唯一标识，此处填写企业号corpid
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nocestr, // 必填，生成签名的随机串
        signature: res.data.signature, // 必填，签名，见附录1
        jsApiList: ['chooseImage', 'openLocation'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
      });
      wx.error(function (err) {
        console.error('微信 JS-SDK 配置失败', err);
      });
    }
  });
}
onMounted(() => {
  getStaticAllData()
  goToApp()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(Tabbar)
  ], 64))
}
}

})